import { CornerData } from "api/types/sketch";
import { CornerRadius } from "api/types/sketch";
import { Vector2 } from "api/types/sketch";
import { getAngle } from "functions/sketch/math";
import { getDistantPoint } from "functions/sketch/math";
import { toRadians } from "functions/sketch/math";
import { makeAnglePositive } from "functions/sketch/math";
import { getAngleOnSecondHalfCornerSeam } from "../seam";
import { constructRadiusCorner } from "../../corner/construct";
import { describeArc } from "functions/sketch/path";

export function drawSecondHalfPrintCutRadiusCorner(
  painter: any,
  i: number,
  previous_location: Vector2,
  current_location: Vector2,
  next_location: Vector2,
  radius: number,
  zoom: number
): CornerData {
  const cut_angle: number = Math.round(makeAnglePositive((getAngle(previous_location, current_location) + 90), false) * 100) / 100;
  const next_angle: number = Math.round(makeAnglePositive((getAngle(current_location, next_location) + 90), false) * 100) / 100;
  const angle: number = getAngleOnSecondHalfCornerSeam(cut_angle, next_angle);
  const corner_radius: CornerRadius = constructRadiusCorner(
    angle,
    current_location,
    next_angle,
    radius * zoom
  );
  let first_point: Vector2 | null = null;

  const start_point: Vector2 = getDistantPoint(corner_radius.center_point, cut_angle, radius * 4);

  if (i === 0) {
    first_point = start_point;
    painter.moveTo(start_point.X, start_point.Y);
  }
  else {
    painter.lineTo(start_point.X, start_point.Y);
  }

  painter.lineTo(corner_radius.end_point.X, corner_radius.end_point.Y);

  const circle_path: string = describeArc(
    corner_radius.center_point.X,
    corner_radius.center_point.Y,
    corner_radius.radius,
    corner_radius.radius,
    corner_radius.end_angle,
    toRadians(cut_angle - 90)
  );

  painter.path(circle_path);
  painter.moveTo(corner_radius.end_point.X, corner_radius.end_point.Y);

  return {
    first_point: first_point,
    last_point: corner_radius.end_point
  }
}
